import { GetAuthFlowViews } from '../../../../modules/auth';
import { translations } from '../../i18n';
import { SignInFlowViewId } from '../../types';
import { RANDOM_SIGN_IN_VIEW_VARIANT, SignInView } from '../views';

export const signInFlowViews: GetAuthFlowViews = (params) => {
  const { intl } = params;
  const {
    leftContentTitleTranslation: signInViewLeftTitleTranslation,
    ...signInViewVariantData
  } = RANDOM_SIGN_IN_VIEW_VARIANT;

  return {
    [SignInFlowViewId.SIGN_IN]: {
      title: intl.formatMessage(translations.signInView.title),
      leftContentTitle: signInViewLeftTitleTranslation
        ? intl.formatMessage(signInViewLeftTitleTranslation)
        : undefined,
      ...signInViewVariantData,
      backButtonHref: '/',
      children: <SignInView />,
    },
  };
};
